import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  BackgroundContainer,
  AbsolutePositioned
} from '../../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../../components/Layout/Line';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';

import Logo from '../../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import GifViewer from '../../../../components/GifViewer';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/neva/neva-feature.png';
import iphone from '../../../../assets/images/pages/neva/neva_iphone.png';

const OverlayBackground = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  background: url(${background}) center no-repeat;
  background-size: cover;
  opacity: 0.9;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitlePosition = styled.div`
  margin: 90px 0 0 0;
  @media ${device.tablet} {
    margin: 53px 0 0 0;
  }
  @media ${device.laptopL} {
    margin: 154px 0 0 0;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;

  .title {
    max-width: 642px;
  }

  .subtext {
    max-width: 430px;
  }
`;

const Content = ContentContainer.extend`
  position: relative;
`;

const IPhonePosition = styled.div`
  display: none;

  @media ${device.mobileL} {
    display: block;
    position: absolute;
    right: 23px;
    width: 100%;
    top: 154px;
    max-width: 317px;
  }

  @media ${device.tablet} {
    top: unset;
    bottom: 139px;
  }

  @media ${device.laptop} {
    bottom: unset;
    top: 154px;
    max-width: 352px;
  }

  img {
    width: 100%;
  }
`;

const FeatureScreen = () => (
  <Screen background={brandColors.blue}>
    <OverlayBackground />
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentHolder>
      <Logo />
      <Content>
        <TitlePosition>
          <Title className="title" subtitle="case study" color={brandColors.white}>
            The <Highlight>making</Highlight> of an industry leader
            <Subtext className="subtext">
              Valneva asked for a learning experience that would enable and empower pharmacists to
              provide travel vaccination and malaria prophylaxis service, in-pharmacy.
            </Subtext>
          </Title>
        </TitlePosition>
        <IPhonePosition>
          <GifViewer imgSrc={iphone} title="neva iphone view" gifSrc={iphone} />
        </IPhonePosition>
      </Content>
    </ContentHolder>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/Feature.jsx